/* eslint-disable max-len */
import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  oversightSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import editAgendaDialog from '../../dialog.editAgendaDialog';
import markAuditCompleteConfirmDialog from '../../../auditTrail/audits/dialog.markAuditCompleteConfirmDialog';
import agendaCategory from '../agendaCategories';
import controller from './active-agenda.controller';
import directive from './active-agenda.directive';


export default angular.module('app.components.advisory.oversight.activeAgenda', [
  alerts,
  oversightDataService,
  oversightSharedModelService,
  confirmDialog,
  constants,
  editAgendaDialog,
  agendaCategory,
  loaderService,
  markAuditCompleteConfirmDialog,
  orgDataService,
  ssDialogService,
])
  .directive('activeAgenda', directive)
  .controller('ActiveAgendaController', controller)
  .name;

console.log('app.components.advisory.oversight.activeAgenda created');
